export default "__VITE_ASSET__Ccf$gZbb__"